import * as React from 'react';

import * as main from '../styles/main.module.scss';
import * as tasks from '../styles/tasks.module.scss';

export const Tasks = () => {
  return (
    <section>
      <div className="container">
        <h2 className={main.mainTitle}>Изучение английского языка на 90 % состоит из решения трёх задач:</h2>
        <div className={tasks.tasks__wrapper}>
          <div className={tasks.tasks__item}>
            <div className={tasks.tasks__text}>
              <span className={`${tasks.tasks__number} ${tasks.tasks__number_1}`}></span>
              <h3 className={tasks.tasks__title}>Запоминание слов</h3>
              <p>
                — это главная составляющая языка: без слов нельзя ни читать, ни писать, ни понимать, ни говорить, ни
                даже выполнять упражнения.
              </p>
              <p>
                <strong>Обычный подход:</strong> зубрёжка и,как следствие, забывание.
              </p>
              <p>
                <strong>Наш подход:</strong> запоминание с помощью мнемотехник со скоростью 100 слов в час и сохранение
                в долговременную память.
              </p>
            </div>
            <div className={tasks.tasks__vid}>
              <div className={tasks.tasks__vid_bg}>
                <div className={tasks.tasks__vid_wrapper}>
                  <iframe className={tasks.tasks__vid_wrapper_iframe}
                          title={'65395_jBgwkbiGNDob9WL'}
                          allow="autoplay; encrypted-media"
                          src="https://65395.servicecdn.ru/videos/65395_jBgwkbiGNDob9WL"
                          frameBorder="0"
                          allowFullScreen
                  ></iframe>
                </div>
              </div>
              <p className={tasks.tasks__vid_title}>Прямо сейчас выучите 10 новых слов со скоростью 100 в час</p>
            </div>
          </div>
          <div className={tasks.tasks__item}>
            <div className={`${tasks.tasks__text} ${tasks.tasks__text_reverse}`}>
              <span className={`${tasks.tasks__number} ${tasks.tasks__number_2}`}></span>
              <h3 className={tasks.tasks__title}>Изучение грамматики</h3>
              <p>
                — на это тратится основное время в школе, вузе и на курсах. А ведь грамматика английского — одна из
                самых простых грамматик в мире.
              </p>
              <p>
                <strong>Обычный подход:</strong> бесконечные правила подаются в виде сложного текста и быстро
                забываются.
              </p>
              <p>
                <strong>Наш подход:</strong> видео на 3–7 минут, где грамматика объясняется на простых схемах и сразу
                выводится в практику.
              </p>
            </div>
            <div className={tasks.tasks__vid}>
              <div className={tasks.tasks__vid_bg}>
                <div className={tasks.tasks__vid_wrapper}>
                  <iframe className={tasks.tasks__vid_wrapper_iframe}
                          title={'65395_Vhzy7Ol6GzLYwwv'}
                          allow="autoplay; encrypted-media"
                          src="https://65395.servicecdn.ru/videos/65395_Vhzy7Ol6GzLYwwv"
                          frameBorder="0"
                          allowFullScreen
                  ></iframe>
                </div>
              </div>
              <p className={tasks.tasks__vid_title}>Разбираем тему предлогов времени за 3 минуты</p>
            </div>
          </div>
          <div className={tasks.tasks__item}>
            <div className={tasks.tasks__text}>
              <span className={`${tasks.tasks__number} ${tasks.tasks__number_3}`}></span>
              <h3 className={tasks.tasks__title}>Освоение разговорного навыка</h3>
              <p>
                — это конечная цель изучения языка, без вывода в речь слова и грамматика бесполезны и быстро забываются.
              </p>
              <p>
                <strong>Обычный подход:</strong> неэффективные упражнения и разговорная практика (10–50 разрозненных
                фраз за урок).
              </p>
              <p>
                <strong>Наш подход:</strong> речевой тренажёр со скоростью 1 500 фраз в час с доведением каждой
                конструкции до автоматизма.
              </p>
            </div>
            <div className={tasks.tasks__vid}>
              <div className={tasks.tasks__vid_bg}>
                <div className={tasks.tasks__vid_wrapper}>
                  <iframe className={tasks.tasks__vid_wrapper_iframe}
                          title={'65395_S2d3vHKGJq4FN6Lf'}
                          allow="autoplay; encrypted-media"
                          src="https://65395.servicecdn.ru/videos/65395_S2d3vHKGJq4FN6Lf"
                          frameBorder="0"
                          allowFullScreen
                  ></iframe>
                </div>
              </div>

              <p className={tasks.tasks__vid_title}>Выводим в речь важнейшую грамматическую конструкцию</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
